import React, { useState } from "react";
import soundService from "../../utils/soundService";

const WordCard = ({
  sinhalaWord,
  englishWord,
  pronunciation,
  image,
  onClick,
  spoken,  // { sinhala, pronunciation } - spoken/colloquial version
  isFormal,  // true if this is explicitly a formal word
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [playingSpoken, setPlayingSpoken] = useState(false);

  const handleClick = async () => {
    console.log("=== WORDCARD MAIN CLICK ===");
    console.log("Main word:", sinhalaWord);
    console.log("Audio path:", soundService.getWordAudioPath(sinhalaWord));

    if (onClick) onClick(pronunciation);

    if (soundService.isSupported()) {
      setIsPlaying(true);
      try {
        await soundService.speakSinhalaWord(sinhalaWord, pronunciation);
        console.log("Main audio playback completed");
      } catch (error) {
        console.error("Error playing sound:", error);
      }
      setIsPlaying(false);
    }
  };

  const handleSpokenClick = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    console.log("=== WORDCARD SPOKEN CLICK ===");
    console.log("Spoken word:", spoken?.sinhala);
    console.log("Audio path:", soundService.getWordAudioPath(spoken?.sinhala));

    if (soundService.isSupported() && spoken) {
      setPlayingSpoken(true);
      try {
        await soundService.speakSinhalaWord(spoken.sinhala, spoken.pronunciation);
        console.log("Audio playback completed");
      } catch (error) {
        console.error("Error playing spoken sound:", error);
      }
      setPlayingSpoken(false);
    }
  };

  return (
    <div
      className={`word-card ${isPlaying ? "playing" : ""} ${image ? "has-image" : ""} ${spoken ? "has-spoken" : ""}`}
      onClick={handleClick}
      title={`Click to hear: ${sinhalaWord} (${pronunciation})`}
    >
      {image && <div className="word-image">{image}</div>}
      <div className="word-sinhala">
        {sinhalaWord}
        {(isFormal || spoken) && <span className="word-tag formal">formal</span>}
        <span className={`audio-icon ${isPlaying ? 'playing' : ''}`}>🔊</span>
      </div>
      <div className="word-english">{englishWord}</div>
      <div className="word-pronunciation">{pronunciation}</div>

      {spoken && (
        <button
          type="button"
          className={`spoken-variant ${playingSpoken ? "playing" : ""}`}
          onClick={handleSpokenClick}
          title={`Click to hear spoken: ${spoken.sinhala}`}
        >
          <div className="spoken-label">
            <span className="word-tag spoken">spoken</span>
          </div>
          <div className="spoken-sinhala">
            {spoken.sinhala}
            <span className={`audio-icon ${playingSpoken ? 'playing' : ''}`}>🔊</span>
          </div>
          <div className="spoken-pronunciation">{spoken.pronunciation}</div>
        </button>
      )}
    </div>
  );
};

export default WordCard;
